export const summerWithFlowProductS = {
    mainPromoHeadline:
      "products.product.promotions.summerWithFlow.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.summerWithFlow.heading.image",
      title: "products.productS.promotions.summerWithFlow.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productS.promotions.summerWithFlow.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productS.promotions.summerWithFlow.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productS.promotions.summerWithFlow.footer",
    total: {
      headline: "products.productS.promotions.summerWithFlow.total.headline",
      priceBefore: "products.productS.promotions.summerWithFlow.total.priceBefore",
      priceAfter: "products.productS.promotions.summerWithFlow.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.summerWithFlow.discount.heading",
      title: "products.productS.promotions.summerWithFlow.discount.title",
      amount: "products.productS.promotions.summerWithFlow.discount.amount",
      code: {
        description:
          "products.productS.promotions.summerWithFlow.discount.code.description",
        promoCode:
          "products.productS.promotions.summerWithFlow.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productS.promotions.summerWithFlow.items.item1.title",
        description:
          "products.productS.promotions.summerWithFlow.items.item1.description",
        priceBefore:
          "products.productS.promotions.summerWithFlow.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.summerWithFlow.items.item1.priceAfter",
      },
      item2: {
        title: "products.productS.promotions.summerWithFlow.items.item2.title",
        description:
          "products.productS.promotions.summerWithFlow.items.item2.description",
        priceBefore:
          "products.productS.promotions.summerWithFlow.items.item2.priceBefore",
        priceAfter: "products.productS.promotions.summerWithFlow.items.item2.priceAfter",
      },
      item3: {
        title: "products.productS.promotions.summerWithFlow.items.item3.title",
        description:
          "products.productS.promotions.summerWithFlow.items.item3.description",
        priceBefore:
          "products.productS.promotions.summerWithFlow.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.summerWithFlow.items.item3.priceAfter",
      },
      item4: {
        title: "products.productS.promotions.summerWithFlow.items.item4.title",
        description:
          "products.productS.promotions.summerWithFlow.items.item4.description",
        priceBefore:
          "products.productS.promotions.summerWithFlow.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.summerWithFlow.items.item4.priceAfter",
      },
      item5: {
        title: "products.productS.promotions.summerWithFlow.items.item5.title",
        description:
          "products.productS.promotions.summerWithFlow.items.item5.description",
        priceBefore:
          "products.productS.promotions.summerWithFlow.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.summerWithFlow.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateSummerWithFlowProductS = {
    mainPromoHeadline:
      "products.productS.promotions.flatrateSummerWithFlow.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.flatrateSummerWithFlow.heading.image",
      title: "products.productS.promotions.flatrateSummerWithFlow.heading.title",
    },
    footer: "products.productS.promotions.flatrateSummerWithFlow.footer",
    total: {
      headline:
        "products.productS.promotions.flatrateSummerWithFlow.total.headline",
      priceBefore:
        "products.productS.promotions.flatrateSummerWithFlow.total.priceBefore",
      priceAfter:
        "products.productS.promotions.flatrateSummerWithFlow.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.summerWithFlow.discount.heading",
      title: "products.productS.promotions.flatrateSummerWithFlow.discount.title",
      amount: "products.productS.promotions.flatrateSummerWithFlow.discount.amount",
      code: {
        description:
          "products.productS.promotions.flatrateSummerWithFlow.discount.code.description",
        promoCode:
          "products.productS.promotions.flatrateSummerWithFlow.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productS.promotions.flatrateSummerWithFlow.items.item1.title",
        description:
          "products.productS.promotions.flatrateSummerWithFlow.items.item1.description",
        priceBefore:
          "products.productS.promotions.flatrateSummerWithFlow.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSummerWithFlow.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productS.promotions.flatrateSummerWithFlow.items.item2.title",
        description:
          "products.productS.promotions.flatrateSummerWithFlow.items.item2.description",
        priceBefore:
          "products.productS.promotions.flatrateSummerWithFlow.items.item2.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSummerWithFlow.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productS.promotions.flatrateSummerWithFlow.items.item3.title",
        description:
          "products.productS.promotions.flatrateSummerWithFlow.items.item3.description",
        priceBefore:
          "products.productS.promotions.flatrateSummerWithFlow.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSummerWithFlow.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productS.promotions.flatrateSummerWithFlow.items.item4.title",
        description:
          "products.productS.promotions.flatrateSummerWithFlow.items.item4.description",
        priceBefore:
          "products.productS.promotions.flatrateSummerWithFlow.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSummerWithFlow.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productS.promotions.flatrateSummerWithFlow.items.item5.title",
        description:
          "products.productS.promotions.flatrateSummerWithFlow.items.item5.description",
        priceBefore:
          "products.productS.promotions.flatrateSummerWithFlow.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSummerWithFlow.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productS.promotions.flatrateSummerWithFlow.items.item6.title",
        description:
          "products.productS.promotions.flatrateSummerWithFlow.items.item6.description",
        priceBefore:
          "products.productS.promotions.flatrateSummerWithFlow.items.item6.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateSummerWithFlow.items.item6.priceAfter",
      },
    },
  };
  
  export const summerWithFlowProductX = {
    mainPromoHeadline:
      "products.productX.promotions.summerWithFlow.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.summerWithFlow.heading.image",
      title: "products.productX.promotions.summerWithFlow.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productX.promotions.summerWithFlow.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productX.promotions.summerWithFlow.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productX.promotions.summerWithFlow.footer",
    total: {
      headline: "products.productX.promotions.summerWithFlow.total.headline",
      priceBefore: "products.productX.promotions.summerWithFlow.total.priceBefore",
      priceAfter: "products.productX.promotions.summerWithFlow.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.summerWithFlow.discount.heading",
      title: "products.productX.promotions.summerWithFlow.discount.title",
      amount: "products.productX.promotions.summerWithFlow.discount.amount",
      code: {
        description:
          "products.productX.promotions.summerWithFlow.discount.code.description",
        promoCode:
          "products.productX.promotions.summerWithFlow.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productX.promotions.summerWithFlow.items.item1.title",
        description:
          "products.productX.promotions.summerWithFlow.items.item1.description",
        priceBefore:
          "products.productX.promotions.summerWithFlow.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.summerWithFlow.items.item1.priceAfter",
      },
      item2: {
        title: "products.productX.promotions.summerWithFlow.items.item2.title",
        description:
          "products.productX.promotions.summerWithFlow.items.item2.description",
        priceBefore:
          "products.productX.promotions.summerWithFlow.items.item2.priceBefore",
        priceAfter: "products.productX.promotions.summerWithFlow.items.item2.priceAfter",
      },
      item3: {
        title: "products.productX.promotions.summerWithFlow.items.item3.title",
        description:
          "products.productX.promotions.summerWithFlow.items.item3.description",
        priceBefore:
          "products.productX.promotions.summerWithFlow.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.summerWithFlow.items.item3.priceAfter",
      },
      item4: {
        title: "products.productX.promotions.summerWithFlow.items.item4.title",
        description:
          "products.productX.promotions.summerWithFlow.items.item4.description",
        priceBefore:
          "products.productX.promotions.summerWithFlow.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.summerWithFlow.items.item4.priceAfter",
      },
      item5: {
        title: "products.productX.promotions.summerWithFlow.items.item5.title",
        description:
          "products.productX.promotions.summerWithFlow.items.item5.description",
        priceBefore:
          "products.productX.promotions.summerWithFlow.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.summerWithFlow.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateSummerWithFlowProductX = {
    mainPromoHeadline:
      "products.productX.promotions.flatrateSummerWithFlow.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.flatrateSummerWithFlow.heading.image",
      title: "products.productX.promotions.flatrateSummerWithFlow.heading.title",
    },
    footer: "products.productX.promotions.flatrateSummerWithFlow.footer",
    total: {
      headline:
        "products.productX.promotions.flatrateSummerWithFlow.total.headline",
      priceBefore:
        "products.productX.promotions.flatrateSummerWithFlow.total.priceBefore",
      priceAfter:
        "products.productX.promotions.flatrateSummerWithFlow.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.summerWithFlow.discount.heading",
      title: "products.productX.promotions.flatrateSummerWithFlow.discount.title",
      amount: "products.productX.promotions.flatrateSummerWithFlow.discount.amount",
      code: {
        description:
          "products.productX.promotions.flatrateSummerWithFlow.discount.code.description",
        promoCode:
          "products.productX.promotions.flatrateSummerWithFlow.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productX.promotions.flatrateSummerWithFlow.items.item1.title",
        description:
          "products.productX.promotions.flatrateSummerWithFlow.items.item1.description",
        priceBefore:
          "products.productX.promotions.flatrateSummerWithFlow.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSummerWithFlow.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productX.promotions.flatrateSummerWithFlow.items.item2.title",
        description:
          "products.productX.promotions.flatrateSummerWithFlow.items.item2.description",
        priceBefore:
          "products.productX.promotions.flatrateSummerWithFlow.items.item2.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSummerWithFlow.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productX.promotions.flatrateSummerWithFlow.items.item3.title",
        description:
          "products.productX.promotions.flatrateSummerWithFlow.items.item3.description",
        priceBefore:
          "products.productX.promotions.flatrateSummerWithFlow.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSummerWithFlow.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productX.promotions.flatrateSummerWithFlow.items.item4.title",
        description:
          "products.productX.promotions.flatrateSummerWithFlow.items.item4.description",
        priceBefore:
          "products.productX.promotions.flatrateSummerWithFlow.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSummerWithFlow.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productX.promotions.flatrateSummerWithFlow.items.item5.title",
        description:
          "products.productX.promotions.flatrateSummerWithFlow.items.item5.description",
        priceBefore:
          "products.productX.promotions.flatrateSummerWithFlow.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSummerWithFlow.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productX.promotions.flatrateSummerWithFlow.items.item6.title",
        description:
          "products.productX.promotions.flatrateSummerWithFlow.items.item6.description",
        priceBefore:
          "products.productX.promotions.flatrateSummerWithFlow.items.item6.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateSummerWithFlow.items.item6.priceAfter",
      },
    },
  };
  